require('../libs/jquery-ui-1.12.1.custom/jquery-ui.min.js');

import STATE from  '../app/state.js';

class Search {
    constructor(m, dom, register) {
        this.search = $(dom);
        this.map = m;
        this.register = register;
        const self = this;
        this.search.on('keypress', function (e) {
            if (e.which == 13) {
                self.search.autocomplete("close");
            }
        });
        this.search.on('click', function () {
            this.select();
        });
    }
    
    clear() {
        this.search.autocomplete().val('');
    }
    /**
     * Makes searchbox autocomplete ready.
     */
    init() {
        var self = this;
        let successFn = self.register === 'dam' ? self.damResponse : self.lakeResponse;
        let selectFn = self.register === 'dam' ? self.damInfo : self.lakeInfo;

        successFn = successFn.bind(self);
        selectFn = selectFn.bind(self);

        this.search.autocomplete({
            source: function (request, response) {
                $.ajax({
                    url: `./rest/search`,
                    dataType: "json",
                    data: {
                        maxRows: 20,
                        term: request.term,
                        register: self.register,
                        damFilter: JSON.stringify(STATE.damFilter)
                    },
                    traditional: true,
                    success: function (data) {
                        response($.map(data, successFn));
                    }
                });
            },
            minLength: 2,
            select: function (event, ui) {
                selectFn(ui.item.value);
                self.clear();
            },
            open: function () {
                $(this).removeClass("ui-corner-all").addClass("ui-corner-top");
            },
            close: function () {
                $(this).removeClass("ui-corner-top").addClass("ui-corner-all");
                self.clear();
            },
            clear: function () {
                $(this).val('');
            }
        });
    }

    lakeResponse(item) {
        return {
            label: item.value.properties.SJOID + ", " + item.value.properties.Register.SNAMN,
            value: item.value.properties.SJOID
        };
    }

    damResponse(item) {
        return {
            label: item.label + ", " + item.value.properties.DNAMN,
            value: item.label
        };
    }

    lakeInfo(term) {
        const self = this;
        self.getInfo({ term: term, register: self.register }).done(function (json) {
            self.map.addLakeFeature(json);
        });
    }
    
    getInfo(data) {
        return $.ajax(`./rest/search/term`, {
            type: 'GET',
            contentType: 'application/json',
            traditional: true,
            data: data,
            dataType: 'json'
        });
    }
    
    damInfo(term) {
        const self = this;
        self.getInfo({ term: term, register: self.register }).done(function (json) {
            self.map.addDamFeature(json);
        });
    };
}

export { Search };
